<div class="container-fluid h-100 bg-white m-t-5">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="p-h-40 text-center">
<!--            <img class="img-fluid" alt="" src="assets/images/logo/logohtnm.jpg">-->
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-8 m-h-auto">
                    <div class="text-center m-b-50">
                        <img class="img-fluid w-90" src="assets/images/others/error-2.png" alt="">
                        <h2 class="font-weight-light font-size-30 m-t-60 m-b-20">Sorry, Chúng tôi đang bảo trì hệ thống...</h2>
                        <p class="w-70 lh-1-8 m-h-auto font-size-17">Rất tiếc là trang web đang tạm ngừng hoạt động để bảo trì một chút vào lúc này. Nhưng chúng tôi đang cố gắng hết sức để khắc phục tình trạng này.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex p-h-40 justify-content-between">
            <span class=""></span>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Legal</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Privacy</a>
                </li>
            </ul>
        </div>
    </div>
</div>
